import React, { useState, useEffect } from 'react';
import axios from '../../api/axios';
import './Shared.css';

const Clase = () => {
  const [clase, setClase] = useState([]);
  const [institutii, setInstitutii] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingClasa, setEditingClasa] = useState(null);
  const [formData, setFormData] = useState({
    instituție: '',
    numeClasa: '',
    numarCopii: '',
    educatoare: '',
    telefon: ''
  });

  useEffect(() => {
    loadClase();
    loadInstitutii();
  }, []);

  const loadClase = async () => {
    try {
      const response = await axios.get('/api/clase');
      setClase(response.data);
    } catch (error) {
      console.error('Eroare la încărcare clase:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadInstitutii = async () => {
    try {
      const response = await axios.get('/api/admin/institutii');
      setInstitutii(response.data);
    } catch (error) {
      console.error('Eroare la încărcare instituții:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingClasa) {
        await axios.put(`/api/admin/clase/${editingClasa._id}`, formData);
      } else {
        await axios.post('/api/admin/clase', formData);
      }
      loadClase();
      closeModal();
    } catch (error) {
      console.error('Eroare la salvare clasă:', error);
      alert('Eroare la salvare clasă');
    }
  };

  const handleEdit = (clasa) => {
    setEditingClasa(clasa);
    setFormData({
      instituție: clasa.instituție?._id || '',
      numeClasa: clasa.numeClasa,
      numarCopii: clasa.numarCopii,
      educatoare: clasa.educatoare,
      telefon: clasa.telefon || ''
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Sigur doriți să ștergeți această clasă?')) {
      try {
        await axios.delete(`/api/admin/clase/${id}`);
        loadClase();
      } catch (error) {
        console.error('Eroare la ștergere clasă:', error);
        alert('Eroare la ștergere clasă');
      }
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingClasa(null);
    setFormData({
      instituție: '',
      numeClasa: '',
      numarCopii: '',
      educatoare: '',
      telefon: ''
    });
  };

  if (loading) return <div>Se încarcă...</div>;

  return (
    <div>
      <div className="page-header">
        <div>
          <h1>Gestiune Clase</h1>
          <p>Gestionează clasele din grădinițe și școli</p>
        </div>
        <button className="btn btn-primary" onClick={() => setShowModal(true)}>
          + Adaugă Clasă
        </button>
      </div>

      <div className="card">
        <table>
          <thead>
            <tr>
              <th>Instituție</th>
              <th>Clasă</th>
              <th>Nr. Copii</th>
              <th>Educatoare</th>
              <th>Telefon</th>
              <th>Acțiuni</th>
            </tr>
          </thead>
          <tbody>
            {clase.map((clasa) => (
              <tr key={clasa._id}>
                <td>
                  {clasa.instituție?.tip === 'scoala' ? '🏫' : '🎀'} {clasa.instituție?.nume || '-'}
                </td>
                <td>{clasa.numeClasa}</td>
                <td>{clasa.numarCopii}</td>
                <td>{clasa.educatoare}</td>
                <td>{clasa.telefon || '-'}</td>
                <td>
                  <button className="btn btn-secondary btn-sm" onClick={() => handleEdit(clasa)}>
                    Editează
                  </button>
                  <button className="btn btn-danger btn-sm" onClick={() => handleDelete(clasa._id)}>
                    Șterge
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingClasa ? 'Editează Clasa' : 'Adaugă Clasă Nouă'}</h2>
              <button className="modal-close" onClick={closeModal}>&times;</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Instituție *</label>
                <select
                  value={formData.instituție}
                  onChange={(e) => setFormData({ ...formData, instituție: e.target.value })}
                  required
                >
                  <option value="">Selectează instituție...</option>
                  {institutii.map((inst) => (
                    <option key={inst._id} value={inst._id}>
                      {inst.tip === 'scoala' ? '🏫' : '🎀'} {inst.nume} ({inst.tip})
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Nume Clasă *</label>
                <input
                  type="text"
                  value={formData.numeClasa}
                  onChange={(e) => setFormData({ ...formData, numeClasa: e.target.value })}
                  required
                  placeholder="ex: Grupa Albinuțelor"
                />
              </div>
              <div className="form-group">
                <label>Număr Copii *</label>
                <input
                  type="number"
                  value={formData.numarCopii}
                  onChange={(e) => setFormData({ ...formData, numarCopii: e.target.value })}
                  required
                  min="0"
                />
              </div>
              <div className="form-group">
                <label>Nume Educatoare *</label>
                <input
                  type="text"
                  value={formData.educatoare}
                  onChange={(e) => setFormData({ ...formData, educatoare: e.target.value })}
                  required
                  placeholder="ex: Maria Popescu"
                />
              </div>
              <div className="form-group">
                <label>Telefon</label>
                <input
                  type="tel"
                  value={formData.telefon}
                  onChange={(e) => setFormData({ ...formData, telefon: e.target.value })}
                  placeholder="ex: 0722123456"
                />
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={closeModal}>
                  Anulează
                </button>
                <button type="submit" className="btn btn-primary">
                  {editingClasa ? 'Salvează' : 'Adaugă'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Clase;
